<template>
  <div></div>
</template>

<script>
  import emailErrorsTypes from '@/data/static/emailErrorsTypes';

  export default {
    name: 'callback',
    created() {
      const { email, success, resetEmail, message } = this.$route.query;
      if (resetEmail) {
        if (success === 'true') {
          this.$router.push({ name: 'Login', query: { resetEmail } });
        } else if (success === 'false') {
          this.$router.push({ name: 'ErrorAuth', query: { resetEmail, email, message, type: emailErrorsTypes.RESET_PASSWORD.name } });
        }
      } else {
        this.$router.push({ name: 'Login' });
      }
    },
  };
</script>



// WEBPACK FOOTER //
// Callback.vue?0c8fab20